// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"530":"7cd2ee30ba8d2edc93d6","540":"2d24c52ba5db0aa8187f","676":"a813b945cd336ca4a7dd","780":"93809c73c3f7629b54f3"}[chunkId] + ".chunk.js";
};